module.exports = __webpack_public_path__ + "img/level_up.da8f2d7c.jpg";